export const PRODUCT = 'paypal_help_center';
export const SPACE = 'SKEISZ';
export const TENANT = 'paypal';